import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pesc-form',
  templateUrl: './pesc-form.component.html',
  styleUrls: ['./pesc-form.component.css']
})
export class PescFormComponent implements OnInit {
  title=""
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/pe-sc/pesc-form/pesc-form.component.ts